import Jobs from "@sourceflow-uk/sourceflow-sdk/jobs";

export { default, getStaticPaths } from "@/pages/jobs/[url_slug]";

export async function getStaticProps({ params: { url_slug } }) {
  const jobs = (await Jobs()).getItems();
  const job = jobs.find(
    (job) => decodeURI(job.url_slug) === decodeURI(url_slug),
  );

  return { props: { locale: "de", job } };
}
